import { connect } from 'react-redux';
import { accessors } from 'store/accessors';

export default connect(mapStateToProps);

export {
  mapStateToProps,
}

function mapStateToProps(state, ownProps) {
  const {
    device: {
      performanceRate,
      platform,
    },
  } = state;
  const emojiArray = ownProps.options.icons || [];
  const consumable = emojiArray.every((emoji) => {
    const asset = accessors.assets.getByUrl(state, emoji.url);
    return Boolean(asset);
  });

  return {
    // isLive,
    // view: state.view,
    emojiArray,
    consumable,
    // silentMode,
    // actions: {},
    performanceRate,
    devicePlatform: platform,
    assets: state.assets,
  };
}
